<template>
  <!--  -->
  <div class="side-panel right com-right hf osy mr-30">
    <div class="side-panel-bg p-20 pb-0">
      <h1 class="f-20 c-satwo">网络与存储 <img src="/imgs/titleicon.png" class="ml-10"></h1>
      <div style="width: 100%; height: 152px;">
        <div class="fr ov ns-bar">
          <div class="ns-label-left">{{ network.name }}</div>
          <div class="ns-label-right">{{ network.used }} / {{ network.total }}</div>
        </div>
        <chart-bar-percent :chartData="Number(network.percentage)" class="f1 mt-10" style="height: 30px;"/>
        <div class="fr ov ns-bar">
          <div class="ns-label-left">{{ storage.name }}</div>
          <div class="ns-label-right">{{ storage.used }} / {{ storage.total }}</div>
        </div>
        <chart-bar-percent :chartData="Number(storage.percentage)" :chartColor="[ '#00E9E3', '#034348' ]"
                           class="f1 mt-10" style="height: 30px;"/>
      </div>
    </div>

    <div class="side-panel-bg p-20 pb-0 mt-20">
      <h1 class="f-20 c-satwo">动环监测 <img src="/imgs/titleicon.png" class="ml-10"></h1>
      <div class="mt-20">
        <div class="monitorcont mb-8">
          <dl v-for="(alert, index) in envEvent" :key="index" class="f-20 tc b">
            <dt :class="`c-color${index + 1}`">{{ alert.count }}</dt>
            <dd><img :src="getIconSrc(index)" alt="告警图标"></dd>
            <dd class="f-10">{{ alert.description }}</dd>
          </dl>
        </div>
        <div style="text-align: center;"><img src="/imgs/saline.png"></div>
        <div class="dcvideoAlarm">
          <div class="videoLft">视频监控告警：<span>{{ videoAlarm.value }}</span></div>
          <div class="videoRt"><a :href="videoURL" target="_blank">视频监控 <img src="/imgs/blikunnewsicon.png"></a></div>
        </div>
        <div class="dcvideoVideo">
          <div class="videoVideoLft"><img src="/imgs/videoImgs/video03.png" class="video-img" /></div>
          <div class="videoVideoRt"><img src="/imgs/videoImgs/video05.png" class="video-img" /></div>
        </div>
      </div>
    </div>

    <div class="side-panel-bg mb-20 p-20 mt-20">
      <h1 class="f-20 c-satwo">安全与合规 <img src="/imgs/titleicon.png" class="ml-10"></h1>
      <chart-line-flow :datasets="networkSecurity" fill showLegend class="f1 mt-10"
                       style="height: 204px;"></chart-line-flow>
    </div>


  </div>
</template>

<script>
import chartLineFlow from './chart-line-flow'
import chartBarPercent from "@/views/sascreen/dc/chart-bar-percent.vue";

export default {
  name: 'com-right',
  components: {
    chartLineFlow,
    chartBarPercent,
  },
  props: {
    resData: {
      type: Object,
      required: true,
    }
  },
  //props: ['datamonitoringData','datanetworkSecurity','dataenergyTrend', 'datacontentMainNews'],
  data() {
    return {
      envEvent: {},
      videoAlarm: {},
      networkSecurity: {},
      network: {},
      storage: {},
      timer: null,

      videoURL: "http://172.16.4.12"
    }
  },
  mounted() {
    this.$nextTick(function () {
      // 初始化dom相关数据
      setTimeout(() => {
        this.envEvent = this.resData.envEvent
        this.videoAlarm = this.resData.videoAlarm
        this.networkSecurity = this.resData.networkSecurity
        this.network = this.resData.networkStorage[0]
        this.storage = this.resData.networkStorage[1]
        this.rollUp();
      }, 300)
    })
  },
  beforeDestroy() {
    this.timer = null;
    clearInterval(this.timer);
  },
  methods: {
    /*向上轮播*/
    rollUp() {
      let ul1 = document.getElementById("publishMain1");
      let ul2 = document.getElementById("publishMain2");
      let box = document.getElementById("publishMain");
      ul2.innerHTML = ul1.innerHTML;
      box.scrollTop = 0;

      function rollStart() {
        console.log(box.scrollTop, ul1.scrollHeight)
        if (box.scrollTop >= 386) {
          box.scrollTop = 0;
        } else {
          box.scrollTop++;
        }
      }

      //this.timer = setInterval(rollStart, 50);
    },
    getIconSrc(index) {
      // 定义图标路径的映射
      const iconPaths = [
        '/imgs/monitorIcon1.png',
        '/imgs/monitorIcon2.png',
        '/imgs/monitorIcon3.png',
        '/imgs/monitorIcon4.png',
        '/imgs/monitorIcon5.png',
        '/imgs/monitorIcon6.png',
        '/imgs/monitorIcon7.png',
        '/imgs/monitorIcon8.png'
      ];
      return iconPaths[index];
    },
  }
}
</script>
<style>
.ns-bar {
  width: 100%;
  font-size: 12px;
  line-height: 24px;
  margin-top: 15px;
}

.ns-label-left {
  float: left;
  text-align: left;
  width: 48%;
}

.ns-label-right {
  float: right;
  text-align: right;
  width: 48%;

}

.monitorcont {
  overflow: hidden;
}

.monitorcont dl {
  width: 25%;
  float: left;
}

.monitorcont dl dt {
  margin-bottom: 2px;
}

.monitorcont dl dd:last-child {
  font-size: 10px;
  margin-bottom: 5px;
}

.c-color1 {
  color: #66FFFF;
}

.c-color2 {
  color: #FBDC4E;
}

.c-color3 {
  color: #FD5465;
}

.c-color4 {
  color: #0A9BBC;
}

.c-color5 {
  color: #0ADB8B;
}

.c-color6 {
  color: #08D4EA;
}

.c-color7 {
  color: #CC9F14;
}

.c-color8 {
  color: #115FC3;
}

.dcvideoAlarm {
  width: 100%;
  overflow: hidden;
}

.videoLft {
  float: left;
}

.videoLft span {
  color: #FF9494;
  font-size: 18px;
  font-family: aldrich, serif;
}

.videoRt {
  float: right;
  color: #00FDFD;
}

.dcvideoVideo {
  margin-top: 20px;
  width: 100%;
  overflow: hidden;
}

.videoVideoLft {
  float: left;
  width: 49%;
  height: 89px;
  background: #123f46;
}

.videoVideoRt {
  float: right;
  width: 49%;
  height: 89px;
  background: #123f46;
}

.video-img {
  width: 100%;
  height: 89px;
}

.newsList {
  padding-right: 0;
}

.centerNews {
  width: 100%;
  height: 200px;
  overflow-y: scroll;
  margin: 8px 0 20px;
}

.centerNewsCon {
  margin-top: 10px;
  padding: 0 10px;
  width: 100%;
  height: 55px;
  background: url("/imgs/blikunnewsbg.png") no-repeat;
  background-size: 100% 55px;
  position: relative;
}

.centerNewsCon .centerNewsContitle {
  width: 90%;
  height: 24px;
  line-height: 22px;
  list-style-type: disc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 5px;
}

.centerNewsCon .ellipsisBox {
  list-style-type: disc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 20px;
  margin-top: 5px;
}

.centerNewsCon .blikunnewsicon {
  position: absolute;
  right: 7px;
  top: 23px;
}

#publishMain1 {
  width: 100%;
}
</style>
